/*
 * @Author: song 
 * @Date: 2018-02-05 17:28:15 
 * @Last Modified by: song
 * @Last Modified time: 2018-02-05 17:36:11
 * 资讯列表页面
 */
export default {
  name: "list",
  list_word: {
    list_word_02: {
      url: '../data/activity_infolist_02_data.json'
    },
  },
};



// WEBPACK FOOTER //
// ./src/projects/huayu/config/dev/informationlist.js